(ns arthur.core
  "The app's entry point.

  port-plan step 3: the hand-written scene plays at 30fps against audio, scrubs,
  and runs at ½× and ¼×."
  (:require [arthur.db :as db]
            [arthur.events.collab :as collab]
            [arthur.events.footage :as footage]
            [arthur.events.history :as history]
            [arthur.events.playback]
            [arthur.events.paint]
            [arthur.events.project :as project]
            [arthur.events.ui]
            [arthur.follow :as follow]
            [arthur.subs.playback]
            [arthur.subs.render]
            [arthur.subs.ui]
            [arthur.ui.index :as index]
            [arthur.ui.player :as player]
            [arthur.ui.shell :as shell]
            [arthur.ui.shortcuts :as shortcuts]
            [re-frame.core :as rf]
            [reagent.dom.client :as rdc]))

(defonce root (atom nil))

(rf/reg-event-db ::init (fn [_ _] db/default))

(defn ^:dev/after-load mount []
  ;; A hot reload changes the scene or the rasteriser and not the playhead, so
  ;; the loop would otherwise sit on an unchanged frame number and never redraw.
  (rf/clear-subscription-cache!)
  (player/refresh-subs!)
  (rdc/render @root [:<> [shell/view] [index/view]]))

(defn init []
  (rf/dispatch-sync [::init])
  ;; A blank document, before the first render. Synchronous for the same reason
  ;; `::init` is: the shell reads the clip's dimensions, and mounting against a
  ;; db that has no clip in it yet is a frame of nothing for no reason.
  (rf/dispatch-sync [::project/new])
  ;; What the server already holds, asked for once. The list is small — a row per
  ;; ingested take — and having it before the first click is what lets the footage
  ;; picker be a picker rather than a path to type.
  (rf/dispatch [::footage/refresh])
  (rf/dispatch [::project/list-symbols])
  ;; After the blank document, so an address that names a project opens it over
  ;; the blank one, and the blank one is what a bad address leaves on screen.
  (follow/install!)                     ; following someone: arthur.follow
  (collab/start!)
  (shortcuts/install!)
  (reset! root (rdc/create-root (js/document.getElementById "app")))
  (mount)
  (player/start!))
